const parseDataChartYearToDate = (data, isVolume = true) => {
  let dataChart = [
    { division: "JAN", name: "january" },
    { division: "FEB", name: "february" },
    { division: "MAR", name: "march" },
    { division: "APR", name: "april" },
    { division: "MAY", name: "may" },
    { division: "JUN", name: "june" },
    { division: "JUL", name: "july" },
    { division: "AUG", name: "august" },
    { division: "SEP", name: "september" },
    { division: "OCT", name: "october" },
    { division: "NOV", name: "november" },
    { division: "DEC", name: "december" },
  ];

  data.forEach((i) => {
    dataChart.forEach((j) => {
      if (isVolume) {
        j[i.name || i.leasingName] = i[j.name];
      } else {
        const total = countTotalMonth(data, j.name);
        j[i.name || i.leasingName] = total <= 0 ? 0 : (i[j.name] / total) * 100;
      }
    });
  });

  return dataChart;
};

const normalizePercent = (value) => {
  const rounded = Number(value.toFixed(2));
  if (Math.abs(rounded - 100) < 0.01) return 100;
  if (Math.abs(rounded) < 0.01) return 0;

  return rounded;
};

const parseDataChartLast3Year = (data, isVolume = true, year) => {
  let dataChart = [
    { division: `Q-1 ${year-2}`, name: "year2Quartal1" },
    { division: `Q-2 ${year-2}`, name: "year2Quartal2" },
    { division: `Q-3 ${year-2}`, name: "year2Quartal3" },
    { division: `Q-4 ${year-2}`, name: "year2Quartal4" },
    { division: `Q-1 ${year-1}`, name: "year1Quartal1" },
    { division: `Q-2 ${year-1}`, name: "year1Quartal2" },
    { division: `Q-3 ${year-1}`, name: "year1Quartal3" },
    { division: `Q-4 ${year-1}`, name: "year1Quartal4" },
    { division: `Q-1 ${year}`, name: "yearQuartal1" },
    { division: `Q-2 ${year}`, name: "yearQuartal2" },
    { division: `Q-3 ${year}`, name: "yearQuartal3" },
    { division: `Q-4 ${year}`, name: "yearQuartal4" },
  ];

  data.forEach((i) => {
    dataChart.forEach((j) => {
      if (isVolume) {
        j[i.name || i.leasingName] = i[j.name];
      } else {
        const total = countTotalMonth(data, j.name);
        j[i.name || i.leasingName] =
          total <= 0
            ? 0
            : normalizePercent((i[j.name] / total) * 100);
      }
    });
  });

  return dataChart;
};

function parseDataChartFincoyL3Y(items, isPercentage, year) {
  const result = [
    { name: "y-2", division: year - 2 },
    { name: "y-1", division: year - 1 },
    { name: "y", division: year }
  ];

  const total = {
    last2Year: 0,
    last1Year: 0,
    lastYear: 0
  };

  items.forEach((item) => {
    const d = item.dataLastThreeYear?.[0] || {};
    total.last2Year += d.last2Year || 0;
    total.last1Year += d.last1Year || 0;
    total.lastYear += d.lastYear || 0;
  });

  const toPercent = (value, total) =>
    total === 0 ? 0 : Number(((value / total) * 100).toFixed(2));

  items.forEach((item) => {
    const d = item.dataLastThreeYear?.[0] || {};
    const key = item.leasingName || "-";

    result[0][key] = isPercentage
      ? toPercent(d.last2Year || 0, total.last2Year)
      : d.last2Year || 0;

    result[1][key] = isPercentage
      ? toPercent(d.last1Year || 0, total.last1Year)
      : d.last1Year || 0;

    result[2][key] = isPercentage
      ? toPercent(d.lastYear || 0, total.lastYear)
      : d.lastYear || 0;
  });

  return result;
}

function parseDataChartFincoyBranch  (items) {
  const result = [
    { name: "growth", division: "Growth (%)" },
    { name: "lastMonth", division: "Last Month" },
    { name: "thisMonth", division: "This Month" }
  ];

  items.forEach((item) => {
    const key = item.namaCabang || "-";

    result[0][key] = item.growth;
    result[1][key] = item.lastMonth;
    result[2][key] = item.lastYear;
  });

  return result;
};

const parseDataKey = (data) => {
  let dataKey = [];
  data.map((i, idx) => {
    dataKey[idx] = {
      key: i.name || i.leasingName,
      color: generateReadableColor(idx, data.length),
    };
  });
  return dataKey;
};

const parseDataKeyFincoyL3Y = (data) => {
  return data.map((i, idx) => ({
    key: i.leasingName || "-",
    color: generateReadableColor(idx, data?.length),
  }));
};

const parseDataKeyFincoyBranch = (data) => {
  return data.map((i, idx) => ({
    key: i.namaCabang || "-",
    color: generateReadableColor(idx, data?.length),
  }));
};

function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) =>
    Math.round(255 * (l - a * Math.max(Math.min(k(n) - 3, 9 - k(n), 1), -1)))
      .toString(16)
      .padStart(2, "0");
  return `#${f(0)}${f(8)}${f(4)}`;
}

function generateReadableColor(index = 0, total = 20) {
  const hue = (index * (360 / total)) % 360; // evenly spaced hues
  const saturation = 70; // keep color vivid
  const lightness = 65; // avoid dark tones

  return hslToHex(hue, saturation, lightness);
}

function countTotalMonth(data, i) {
  let total = 0;
  data.forEach((d) => {
    total += d[i];
  });
  return total;
}

export const service = {
  parseDataChartYearToDate,
  parseDataKey,
  parseDataChartLast3Year,
  parseDataKeyFincoyL3Y,
  parseDataChartFincoyL3Y,
  parseDataKeyFincoyBranch,
  parseDataChartFincoyBranch
};
